import { z } from 'zod';
import type { RequestKind } from './requests.js';
export const McpPolicySchema = z.object({ mode: z.enum(['standard', 'approval_required']) }).strict();
export type McpPolicy = z.infer<typeof McpPolicySchema>;
// 権限・参加制限、停止、広範囲の破壊、保存停止、設定再読込は人が確認する。
// execute/function は中で承認対象を呼べるため、内容によらず承認する。
export const approvalConsoleCommands = [
  'op',
  'deop',
  'stop',
  'ban',
  'ban-ip',
  'pardon',
  'pardon-ip',
  'kill',
  'fill',
  'clone',
  'forceload',
  'save-off',
  'reload',
  'execute',
  'function',
];
export function consoleNeedsApproval(command: string): boolean {
  const [name = '', ...args] = command.trim().toLowerCase().replace(/^\//, '').split(/\s+/);
  const normalized = name.replace(/^minecraft:/, '');
  if (approvalConsoleCommands.includes(normalized)) return true;
  if (normalized === 'whitelist' && args[0] === 'off') return true;
  // Panel 管理の接続・認証・配置項目を直接書き換えるプラグインコマンドも承認する。
  return args.some((arg) =>
    /^(server-port|server-ip|online-mode|enable-rcon|enable-query|level-name|rcon\..*|query\..*)(=|$)/.test(arg),
  );
}
export const directMcpRequestKinds: readonly RequestKind[] = [
  'create_server',
  'change_software',
  'change_version',
  'change_mods',
  'change_game_settings',
  'change_jvm_args',
  'change_resources',
  'change_world_generation',
  'change_bedrock',
  'change_ports',
];
export function mcpRequestNeedsApproval(kind: RequestKind, params: Record<string, unknown>, mode: McpPolicy['mode']) {
  if (mode === 'approval_required') return true;
  if (kind === 'console_command') return consoleNeedsApproval(String(params.command));
  return !directMcpRequestKinds.includes(kind);
}
